
const FOLLOWED_CONTENT_STORAGE = 'followed-content'
const PREPR_MODELS = Object.freeze({
  program: 'fa9af868-5af3-49db-8b55-ff1155b2a53b',
  person: '3e97b652-7f9f-4b47-91ef-5f63b448a983',
})

export default {
  name: 'EoFollowButton',
  props: {
    contentType: {
      type: String,
      default: null,
      required: true,
    },
    contentId: {
      type: String,
      default: null,
      required: true,
    },
    contentEnvironmentId: {
      type: String,
      default: null,
      required: true,
    },
    contentSlug: {
      type: String,
      default: null,
      required: true,
    },
    contentTitle: {
      type: String,
      default: null,
      required: true,
    },
    contentDescription: {
      type: String,
      default: null,
      required: false,
    },
    contentHero: {
      type: String,
      default: null,
      required: false,
    },
    labelAction: {
      type: String,
      default: 'Volgen',
    },
    labelSingularPast: {
      type: String,
      default: 'Volgend',
    },
    showGuide: {
      type: Boolean,
      default: true,
    },
    redirect: {
      type: Boolean,
      default: false,
    },
    darkMode: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'lg',
    },
  },
  data () {
    return {
      followedContent: [],
      isFollowing: false,
      isMounted: true,
    }
  },
  computed: {
    label () {
      return this.isFollowing ? this.labelSingularPast : this.labelAction
    },
    isUserLoggedIn () {
      return this.$auth.loggedIn
    },
    followData () {
      return {
        id: this.contentId,
        modelId: PREPR_MODELS[this.contentType],
        environmentId: this.contentEnvironmentId,
        slug: this.contentSlug,
        type: this.contentType,
        title: this.contentTitle,
        description: this.contentDescription,
        hero: this.contentHero,
      }
    },
  },
  updated () {
    this.getStoredFollow()
  },
  async mounted () {
    this.isMounted = true

    if (this.isUserLoggedIn && this.contentId) {
      this.getStoredFollow()
      window.addEventListener('follow-changed', this.getStoredFollow)
    }

    if (this.redirect) {
      if (!this.isUserLoggedIn) {
        this.$auth.$storage.setUniversal('redirect', this.$route.path)
      } else {
        this.$auth.$storage.removeUniversal('redirect')
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('follow-changed', this.getStoredFollow)
  },
  methods: {
    onFollow () {
      if (this.isUserLoggedIn) {
        if (this.isFollowing) {
          this.removeFollow()
        } else {
          this.addFollow()
        }
      } else {
        this.login()
      }
    },
    onGuide () {
      window.dispatchEvent(new CustomEvent('follow-guide', {detail:  this.followData}))
    },
    addFollow () {
      this.isFollowing = true
      this.followedContent.push(this.followData)
      this.setStoredFollow()

      this.$emit('follow', this.followData)
      this.trackEvent('follow')
    },
    removeFollow () {
      this.isFollowing = false
      this.followedContent = this.followedContent.filter(content => content?.id != this.contentId)
      this.setStoredFollow()

      this.$emit('unfollow', this.followData)
      this.trackEvent('unfollow')
    },
    login () {
      if (this.redirect) {
        this.$auth.$storage.setUniversal('redirect', this.$route.path) 
      }

      this.$auth.login()
    },
    getStoredFollow () {
      try {
        const storedFollow = JSON.parse(localStorage.getItem(FOLLOWED_CONTENT_STORAGE)) || []
        this.followedContent = storedFollow
        this.isFollowing = storedFollow.some(content => content?.id == this.contentId)
      } catch (e) {
        this.$log.error(e)
        return false
      }
    },
    setStoredFollow () {
      try {
        localStorage.setItem(FOLLOWED_CONTENT_STORAGE, JSON.stringify(this.followedContent))
      } catch (e) {
        this.$log.error(e)
      }
      window.dispatchEvent(new CustomEvent('follow-changed'))
    },
    trackEvent (event) {
      try{
        if (window?.prepr && this.contentId) {
          if (event === 'follow') {
            window.prepr('event', 'Subscribe', { id: this.contentId, constraint: true })
          } else {
            window.prepr('event', 'Unsubscribe', { id: this.contentId, constraint: true })
          }
        }
        if (this.$gtm && event === 'follow') {
          // Send event to GTM
          this.$gtm.push({
            'event': 'eo_follow',
            'content_type': this.contentType,
            'item_id': this.contentId,
          })
        }
      } catch (error) {
        const referrer = process.client && document?.referrer
        const {
          context,
          message = 'Er is iets mis gegaan met het versturen van trackEvent Follow',
          path = referrer,
          severity,
          statusCode = 500,
        } = this.error

        this.$bugsnag.notify(new Error(`${statusCode}: ${message}`), (e) => {
          e.severity = severity || (statusCode === 404 ? 'info' : 'error')
          e.context = context || path
          e.addMetadata('Error info', {
            ...this.error,
            referrer,
          })
        })
      }
    },
  },
}
